import { useContext } from 'react';
import { CARD_STYLES } from '../../../assets/constants/cardStyles';
import { getCardStyleName } from '../../../assets/constants/cardSensitive';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import BottomSheet from '../../shared/BottomSheet/BottomSheet';
import './CardAppearanceSheet.css';

function CardAppearanceSheet({ currentStyle, onClose, onSelect }) {
  const { card } = useContext(TranslationContext);

  return (
    <BottomSheet
      className="card-appearance-sheet"
      panelClassName="card-appearance-sheet__panel"
      title={card.chooseStyle}
      titleId="card-appearance-sheet-title"
      onClose={onClose}
    >
      <div className="card-appearance-sheet__grid" role="listbox" aria-label={card.styleSection}>
        {CARD_STYLES.map((style) => {
          const isSelected = style === currentStyle;

          return (
            <button
              key={style}
              type="button"
              className={
                isSelected
                  ? 'card-appearance-sheet__option card-appearance-sheet__option--selected'
                  : 'card-appearance-sheet__option'
              }
              aria-selected={isSelected}
              role="option"
              onClick={() => onSelect(style)}
            >
              <span
                className={`card-appearance-sheet__swatch card-appearance-sheet__swatch--${style}`}
                aria-hidden="true"
              />
              <span className="card-appearance-sheet__name">
                {getCardStyleName(style, card.styles)}
              </span>
              <span className="card-appearance-sheet__radio" aria-hidden="true">
                <span className="card-appearance-sheet__radio-dot" />
              </span>
            </button>
          );
        })}
      </div>
    </BottomSheet>
  );
}

export default CardAppearanceSheet;
